var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCollapseIconBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "43px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -69 -7 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1.002804398536682  C 0 1.002804398536682  0.000224169110879302 41.99719619750977  0.000224169110879302 41.99719619750977  C 1.384295582771301 43.33426666259766  3.598037481307983 43.33426666259766  4.982108592987061 41.99719619750977  C 4.982108592987061 41.99719619750977  13.39755439758301 34.33937454223633  13.39755439758301 34.33937454223633  C 14.44637107849121 33.3277702331543  15.025789260864258 31.934200286865227  14.99911785125732 30.487422943115234  C 14.99911785125732 30.487422943115234  14.99904346466064 12.51257610321045  14.99904346466064 12.51257610321045  C 15.025691032409668 11.0658016204834  14.44624996185303 9.67224407196045  13.39741706848145 8.660661697387695  C 13.39741706848145 8.660661697387695  4.981872081756592 1.002804398536682  4.981872081756592 1.002804398536682  C 3.597805023193359 -0.3342681229114532  1.384067177772522 -0.3342681229114532  0 1.002804398536682  Z ",
    fillRule: "nonzero",
    fill: "#333333",
    stroke: "none",
    transform: "matrix(1 0 0 1 69 7 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCollapseIconBrown);
export default __webpack_public_path__ + "static/media/sidebar_collapse_icon_brown.6cdea44c125863022a5aed9e44487357.svg";
export { ForwardRef as ReactComponent };